import { UserPhoneNumberSearchResponse } from '@lio/api-types';
import { userQueryKey } from '@services/user/keys';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useSearchUserPhoneNumbers = (userId?: string) => {
  const client = useClient();

  const result = useQuery<UserPhoneNumberSearchResponse>({
    queryKey: [userQueryKey.getWithParams(userId ?? ''), 'phoneNumbers'],
    queryFn: () => client.get(`user/${userId}/phone-number`).json<UserPhoneNumberSearchResponse>(),
    refetchOnWindowFocus: false,
    enabled: !!userId,
  });
  return { ...result, phoneNumbers: result.data?.items ?? [] };
};
